export default {
  'memberArea.title': '會員專區',
  'memberArea.to_next_level': '距離下次升等',
  'memberArea.member_info': '會員資訊',
  'memberArea.invoice_carrier': '發票載具',
  'memberArea.language': '語系切換',
} as Record<string, string>;
